import { LitElement, css, html, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import styles from "./styles.css?inline";
import { template } from "./template";

//@ts-ignore
@customElement("activity-history-search-bar")
export class ActivityHistorySearchBar extends LitElement {
  render() {
    return html`${template(this)}`;
  }

  static styles = css`
    ${unsafeCSS(styles)}
  `;

  @property()
  searchQuery = "";

  _handleSearchChange(event) {
    const selectedItems = event.detail || [];
    const searchQuery = selectedItems.length > 0 ? selectedItems.join(" ") : "";
    const payload = searchQuery.length > 1 ? searchQuery : "";
    this.dispatchEvent(new CustomEvent("onSearchChange", { detail: payload }));
  }
}
